"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var COMMANDS = roosterjs_editor_dom_1.Browser.isFirefox
    ? (_a = {},
        /**
         * Disable these object resizing for firefox since other browsers don't have these behaviors
         */
        _a["enableObjectResizing" /* EnableObjectResizing */] = false,
        _a["enableInlineTableEditing" /* EnableInlineTableEditing */] = false,
        _a) : roosterjs_editor_dom_1.Browser.isIE
    ? (_b = {},
        /**
         * Change the default paragraph separater to DIV. This is mainly for IE since its default setting is P
         */
        _b["defaultParagraphSeparator" /* DefaultParagraphSeparator */] = 'div',
        /**
         * Disable auto link feature in IE since we have our own implementation
         */
        _b["AutoUrlDetect" /* AutoUrlDetect */] = false,
        _b) : {};
/**
 * Execute document command to adjust browser default behavior
 */
function adjustBrowserBehavior(document) {
    Object.keys(COMMANDS).forEach(function (command) {
        // Catch any possible exception since this should not block the initialization of editor
        try {
            document.execCommand(command, false, COMMANDS[command]);
        }
        catch (_a) { }
    });
}
exports.default = adjustBrowserBehavior;
//# sourceMappingURL=adjustBrowserBehavior.js.map